export default "__VITE_ASSET__CiubJFZv__"